/**
 *  RaceCarView
 *
 *  Created by Legman on 27/03/2017.
 *
 */

import Common from "../Common";

/**
 * @class
 * @extends PIXI.Container
 * @memberOf race
 */
export default class RaceCarView extends PIXI.Container {
    constructor() {
        super();

        /**
         * @type {number}
         * @private
         */
        this._curvature = 0;

        /**
         * @type {PIXI.Sprite}
         * @protected
         */
        this._shadow = this.createShadow();
        this._shadow.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(this._shadow);

        /**
         * @member {Object}
         * @protected
         */
        this._wheels = {};

        /**
         * @member {Object}
         * @protected
         */
        this._wheels.front = {};

        /**
         * @member {Object}
         * @protected
         */
        this._wheels.rear = {};

        /**
         * @member {p3.MovieClip}
         * @protected
         */
        this._wheels.front.left = this.createFrontWheel();
        this._wheels.front.left.anchor = new PIXI.Point(0.5, 0.5);
        this._wheels.front.left.offset = new PIXI.Point();
        this._wheels.front.left.looping = true;
        this._wheels.front.left.play();
        this.addChild(this._wheels.front.left);

        /**
         * @member {p3.MovieClip}
         * @protected
         */
        this._wheels.front.right = this.createFrontWheel();
        this._wheels.front.right.anchor = new PIXI.Point(0.5, 0.5);
        this._wheels.front.right.offset = new PIXI.Point();
        this._wheels.front.right.looping = true;
        this._wheels.front.right.scale.x = -1;
        this._wheels.front.right.play();
        this.addChild(this._wheels.front.right);

        /**
         * @member {PIXI.Sprite}
         * @protected
         */
        this._front = this.createFrontLayer();
        this._front.anchor = new PIXI.Point(0.5, 0.5);
        this._front.offset = new PIXI.Point();
        this.addChild(this._front);

        /**
         * @member {p3.MovieClip}
         * @protected
         */
        this._wheels.rear.left = this.createRearWheel();
        this._wheels.rear.left.anchor = new PIXI.Point(0.5, 0.5);
        this._wheels.rear.left.offset = new PIXI.Point();
        this._wheels.rear.left.looping = true;
        this._wheels.rear.left.play();
        this.addChild(this._wheels.rear.left);

        /**
         * @member {p3.MovieClip}
         * @protected
         */
        this._wheels.rear.right = this.createRearWheel();
        this._wheels.rear.right.anchor = new PIXI.Point(0.5, 0.5);
        this._wheels.rear.right.offset = new PIXI.Point();
        this._wheels.rear.right.looping = true;
        this._wheels.rear.right.scale.x = -1;
        this._wheels.rear.right.play();
        this.addChild(this._wheels.rear.right);

        /**
         * @member {PIXI.Sprite}
         * @protected
         */
        this._back = this.createBackLayer();
        this._back.anchor = new PIXI.Point(0.5, 0.5);
        this._back.offset = new PIXI.Point();
        this.addChild(this._back);
    }

    /**
     */
    init() {
    }

    /**
     * @param destroyChildren
     */
    destroy(destroyChildren) {
        this.stopEngine();
    }

    /**
     * @param {number} dt
     * @param {number} distance
     * @param {number} curvature
     * @param {number} gradient
     * @param {number} velocity
     * @param {number} turnVelocity
     * @param {number} jumpOffset
     */
    update(dt, distance, curvature, gradient, velocity, turnVelocity, jumpOffset) {
        if (this._shadow) {
            this._shadow.alpha = 1 - jumpOffset * 0.8;
        }
    }

    /**
     */
    startEngine() {
        this.stopEngine();

        TweenMax.to(this._front.scale, 0.04, {
            y: this._front.scale.y - 0.04,
            yoyo: true,
            repeat: -1
        });

        TweenMax.to(this._back.offset, 0.03, {
            y: this._back.offset.y - 4.0,
            yoyo: true,
            repeat: -1
        });

        TweenMax.to(this._back.scale, 0.04, {
            delay: 0.02,
            y: this._back.scale.y - 0.02,
            yoyo: true,
            repeat: -1
        });
    }

    /**
     */
    stopEngine() {
        TweenMax.killTweensOf(this._front.scale);
        TweenMax.killTweensOf(this._back.offset);
        TweenMax.killTweensOf(this._back.scale);
    }

    /**
     * @returns {PIXI.Sprite}
     */
    createFrontLayer() {
        return new PIXI.Sprite();
    }

    /**
     * @returns {PIXI.Sprite}
     */
    createBackLayer() {
        return new PIXI.Sprite();
    }

    /**
     * @returns {p3.MovieClip}
     */
    createFrontWheel() {
        const sequence = new p3.MovieClipSequence();
        return new p3.MovieClip(sequence);
    }

    /**
     * @returns {p3.MovieClip}
     */
    createRearWheel() {
        const sequence = new p3.MovieClipSequence();
        return new p3.MovieClip(sequence);
    }

    /**
     * @returns {PIXI.Sprite}
     */
    createShadow() {
        return new PIXI.Sprite(PIXI.Texture.EMPTY);
    }

    /**
     */
    showBubblesEffect() {

    }

    /**
     * @returns {PIXI.Sprite}
     */
    get front() {
        return this._front;
    }

    /**
     * @returns {PIXI.Sprite}
     */
    get back() {
        return this._back;
    }
}